export const translations = {
    es: {
        title: "Islas",

        // Botones
        "button.import": "Importar",
        "button.validate": "Validar",
        "button.cancel": "Cancelar",
        "button.accept": "Aceptar",

        // Importar
        "import.title": "Importar islas",
        "import.help":
            "Columnas: Nombre, Descripción, Dirección, Latitud, Longitud, Zona. " +
            "Las islas se buscan por nombre: si existen se actualizan y si no se crean.",
        "import.not-xlsx": "El archivo debe ser un Excel (.xlsx)",
        "import.error": "No se ha podido procesar el Excel",
        "import.success": "Islas importadas correctamente",

        // Resumen
        "summary.news": "Nuevas",
        "summary.updated": "Actualizadas",
        "summary.errors": "Errores",
        "summary.row": "Fila",
        "summary.message": "Mensaje",
    },
    en: {
        title: "Islands",

        // Botones
        "button.import": "Import",
        "button.validate": "Validate",
        "button.cancel": "Cancel",
        "button.accept": "Accept",

        // Importar
        "import.title": "Import islands",
        "import.help":
            "Columns: Name, Description, Address, Latitude, Longitude, Zone. " +
            "Islands are matched by name: existing ones are updated and new ones are created.",
        "import.not-xlsx": "The file must be an Excel (.xlsx)",
        "import.error": "The Excel could not be processed",
        "import.success": "Islands imported successfully",

        // Resumen
        "summary.news": "New",
        "summary.updated": "Updated",
        "summary.errors": "Errors",
        "summary.row": "Row",
        "summary.message": "Message",
    },
};
